import React, { useState, useEffect } from "react";
import PersonaReact from 'persona-react';

import { SlBusyIndicator } from "../editors";

import { LeadService } from '../../_services';

const Persona = (props) => {
    const { leadId, onComplete } = props;
    const [inquirySession, setInquirySession] = useState(null);

    function handleComplete(args) {
        const { status } = args;

        if (onComplete)
            onComplete(status.toLowerCase());
    }

    async function getSession(leadId) {
        if (leadId) {
            let inq = await LeadService.getLeadPersonaInquirySession(leadId);

            if (inq.data) {
                setInquirySession(inq.data);
            }

        } else {
            setInquirySession(null);
        }
    }

    useEffect(() => {
        getSession(leadId);
    }, [leadId]);

    return (
        <div id='persona-container'>
            <SlBusyIndicator visible={!inquirySession} />

            {inquirySession &&
                <PersonaReact
                    inquiryId={inquirySession.inquiryId}
                    sessionToken={inquirySession.sessionToken}
                    environment={inquirySession.environment}
                    onComplete={handleComplete}
                //onReady={(a) => console.dir(a) }
                ///onCancel={({ inquiryId, sessionToken }) => console.log('onCancel')}
                //onError={(error) => console.log(error)}
            />}
        </div>
    )
}

export default Persona;